module.exports = __webpack_public_path__ + "labioplastika_10_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/labioplastika_10_after_tn.jpg
// module id = 1531
// module chunks = 0